"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenedDialogsProvider = exports.useOpenedDialogContext = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var dialogs_reducer_1 = require("./dialogs-reducer");
var openedDialogsDefaults = {
  openedDialogs: [],
  dialogDispatch: function () {}
};
var OpenedDialogContext = React.createContext(openedDialogsDefaults);
var useOpenedDialogContext = function () {
  return React.useContext(OpenedDialogContext);
};
exports.useOpenedDialogContext = useOpenedDialogContext;
var OpenedDialogsProvider = function (_a) {
  var children = _a.children;
  var _b = tslib_1.__read(React.useReducer(dialogs_reducer_1.dialogReducer, []), 2),
    openedDialogs = _b[0],
    dialogDispatch = _b[1];
  var memoizedValue = React.useMemo(function () {
    return {
      openedDialogs: openedDialogs,
      dialogDispatch: dialogDispatch
    };
  }, [openedDialogs, dialogDispatch]);
  return React.createElement(OpenedDialogContext.Provider, {
    value: memoizedValue
  }, children);
};
exports.OpenedDialogsProvider = OpenedDialogsProvider;